<template>
    <div v-if="tagGroups.length" class="list-group border-radius-2 no-border">
        <div class="list-group-item py-2">
            <span class="text-sm mr-2"><strong>{{ $t('tags') }}</strong></span>
            <span v-for="tag in value" :key="tag.id" class="badge badge-secondary mr-1 p-1 px-2 font-weight-normal">{{ tag.name }}</span>
        </div>

        <ScrollPaginator
            :data="tagGroups"
            :filters="filters"
            :submitting="submitting"
            @toPage="toPage"
        >
            <template v-slot:item="{ item: group }">
                <div class="list-group-item">
                    <div class="small"><strong>{{ group.name }}</strong></div>
            
                    <button 
                        v-for="tag in group.tags" 
                        :key="tag.id"
                        :class="[isSelected(tag) ? 'btn-primary' : 'btn-light', 'btn btn-sm mt-2 mr-2']"
                        @click="view_only ? undefined : toggleTag(tag)"
                    >
                        {{ tag.name }}
                    </button>
                </div>
            </template>
            
        </ScrollPaginator>
    </div>
</template>

<script>
import ScrollPaginator from '../Table/ScrollPaginator.vue'

export default {
    components: {
        ScrollPaginator
    },
    mounted() {
        const promise = this.fetchTagGroups()
        if (promise) promise.then(() => { this.loading = false })
    },
    props: {
        value: {
            type: Array,
            default: () => [],
        },
        view_only: Boolean,
    },
    data() {
        return {
            loading: true,
            submitting: false,
            tagGroups: [],
            filters: {
                page: 1,
                page_size: 30,
                total: 0,
                exclude_empty: 1,
            },
        }
    },
    methods: {
        fetchTagGroups() {
            if (this.submitting) return
            this.submitting = true

            return this.$cfetch(`${this.$settings.APIBaseURL}/tags/groups/list`, {
                method: 'POST',
                data: this.filters,
            }).then(res => {
                if (res.status !== 'SUCCESS') throw new Error('Unexpected error fetching tag groups')

                this.tagGroups = res.results
                this.filters.page = res.pagination.page
                this.filters.page_size = res.pagination.page_size
                this.filters.total = res.pagination.total
            }).catch(err => {
                this.$log.error.call(this, err)
                this.$store.commit('openDialog', {
                    title: this.$t('something-went-wrong'),
                    content: this.$t("unexpected-error-fetching-tag-groups"),
                    confirmCallBack: function () {
                        this.$router.push('/settings')
                    }
                })
            }).finally(() => {
                this.submitting = false
            })
        },
        toggleTag(tag) {
            if (this.isSelected(tag)) this.$emit('input', this.value.filter(el => el.id !== tag.id))
            else this.$emit('input', [...this.value, tag])
        },
        isSelected(tag) {
            return this.value.findIndex(el => el.id === tag.id) > -1;
        },
        toPage(pageNo) {
            this.filters.page = pageNo
            this.fetchTagGroups()
        },
    }
}
</script>